export const isTruthyOrZero = (value: any) => Boolean(value) || value === 0
